// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1POti","largestCol":"styles_largestCol__1ds1a","smallestCol":"styles_smallestCol__17R83"};